import React, { useState, useEffect } from "react";
import {
  Box, Typography, Grid, TextField, Paper,
  Avatar, Button, IconButton, CircularProgress
} from "@mui/material";
import { CloudUpload as CloudUploadIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { storage } from "../../../firebase"; // Ensure your firebase config is exported
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function FatherInfo({ form, handleChange }) {
  const [uploading, setUploading] = useState(false);

  // Handle Photo Upload to Firebase Storage
  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      // Create a unique path for the photo
      const storageRef = ref(storage, `father_photos/${Date.now()}_${file.name}`);

      // Upload file
      await uploadBytes(storageRef, file);

      // Get Download URL
      const downloadURL = await getDownloadURL(storageRef);

      // Update form state with the URL
      handleChange("father_photo", downloadURL);
    } catch (error) {
      console.error("Upload error:", error);
      alert("Failed to upload image");
    } finally {
      setUploading(false);
    }
  };

  const fetchAddressFromPincode = async (pin, type = "current") => {
    if (pin.length !== 6) return;
    try {
      const res = await fetch(`https://api.zippopotam.us/in/${pin}`);
      if (!res.ok) return;
      const data = await res.json();
      if (data && data.places && data.places.length > 0) {
        const place = data.places[0];
        const address = `${place["place name"]}, ${place["state"]}`;
        if (type === "current") handleChange("father_currentAddress", address);
        else if (type === "permanent") handleChange("father_permanentAddress", address);
        else if (type === "office") handleChange("father_officeAddress", address);
      }
    } catch (err) {
      console.log("Fetch error:", err);
    }
  };

  return (
    <Box display="flex" justifyContent="center" bgcolor="#f4f6f8" p={2}>
      <Paper sx={{ p: 2, width: "100%", maxWidth: "1200px" }}>

        {/* HEADER */}
        <Box sx={{ background: "teal", color: "#fff", p: 1, mb: 3, borderRadius: 1 }}>
          <Typography fontWeight="bold">
            3) Father's Information (Please fill in BLOCK CAPITAL LETTERS ONLY)
          </Typography>
        </Box>

        <Grid className="row" spacing={3}>
          {/* LEFT SIDE: FORM FIELDS (xs=9) */}
          <Grid className="col-sm-10" item xs={12} md={9}>
            <Grid className="row" spacing={2}>
              <Grid className="col-sm-4 mb-3" item xs={12}>
                <TextField
                  fullWidth
                  label="Name (Start's with Surname)"
                  size="small"
                  value={form.father_name || ""}
                  onChange={(e) => handleChange("father_name", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-4 mb-3" item xs={9}>
                <TextField
                  fullWidth
                  label="Current Residential Address"
                  size="small"
                  value={form.father_currentAddress || ""}
                  onChange={(e) => handleChange("father_currentAddress", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-4 mb-3" item xs={3}>
                <TextField
                  fullWidth
                  label="Pin Code"
                  size="small"
                  value={form.father_currentPin || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleChange("father_currentPin", value);
                    fetchAddressFromPincode(value, "current");
                  }}
                />
              </Grid>

              <Grid className="col-sm-4 mb-3" item xs={9}>
                <TextField
                  fullWidth
                  label="Permanent Residential Address"
                  size="small"
                  value={form.father_permanentAddress || ""}
                  onChange={(e) => handleChange("father_permanentAddress", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-4 mb-3" item xs={3}>
                <TextField
                  fullWidth
                  label="Pin Code"
                  size="small"
                  value={form.father_permanentPin || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleChange("father_permanentPin", value);
                    fetchAddressFromPincode(value, "permanent");
                  }}
                />
              </Grid>

              <Grid className="col-sm-4 mb-3" item xs={6}>
                <TextField fullWidth label="PAN No." size="small" value={form.father_pan || ""} onChange={(e) => handleChange("father_pan", e.target.value)} />
              </Grid>

              <Grid className="col-sm-4 mb-3" item xs={6}>
                <TextField fullWidth label="Adhar No." size="small" value={form.father_adhar || ""} onChange={(e) => handleChange("father_adhar", e.target.value)} />
              </Grid>

              <Grid className="col-sm-4 mb-3" item xs={6}>
                <TextField fullWidth label="Qualification" size="small" value={form.father_qualification || ""} onChange={(e) => handleChange("father_qualification", e.target.value)} />
              </Grid>

              <Grid className="col-sm-4 mb-3" item xs={6}>
                <TextField fullWidth label="Occupation" size="small" value={form.father_occupation || ""} onChange={(e) => handleChange("father_occupation", e.target.value)} />
              </Grid>
              <Grid className="col-sm-4 mb-3" item xs={6}>
                <TextField fullWidth label="Organization" size="small" value={form.father_organization || ""} onChange={(e) => handleChange("father_organization", e.target.value)} />
              </Grid>
              <Grid className="col-sm-4 mb-3" item xs={6}>
                <TextField fullWidth label="Designation" size="small" value={form.father_designation || ""} onChange={(e) => handleChange("father_designation", e.target.value)} />
              </Grid>
              <Grid className="col-sm-4 mb-3" item xs={9}>
                <TextField fullWidth label="Office Address" size="small" value={form.father_officeAddress || ""} onChange={(e) => handleChange("father_officeAddress", e.target.value)} />
              </Grid>
              <Grid className="col-sm-4 mb-3" item xs={3}>
                <TextField fullWidth label="Pin Code" size="small" value={form.father_officePin || ""} onChange={(e) => {
                  const value = e.target.value;
                  handleChange("father_officePin", value);
                  fetchAddressFromPincode(value, "office");
                }} />
              </Grid>
              <Grid className="col-sm-4 mb-3" item xs={12}>
                <TextField fullWidth label="Email ID" size="small" value={form.father_email || ""} onChange={(e) => handleChange("father_email", e.target.value)} />
              </Grid>
              <Grid className="col-sm-4 mb-3" item xs={4}>
                <TextField fullWidth label="Primary No" size="small" value={form.father_mobile1 || ""} onChange={(e) => handleChange("father_mobile1", e.target.value)} />
              </Grid>
              <Grid className="col-sm-4 mb-3" item xs={4}>
                <TextField fullWidth label="Mobile 2" size="small" value={form.father_mobile2 || ""} onChange={(e) => handleChange("father_mobile2", e.target.value)} />
              </Grid>
              <Grid className="col-sm-4 mb-3" item xs={4}>
                <TextField fullWidth label="Landline" size="small" value={form.father_landline || ""} onChange={(e) => handleChange("father_landline", e.target.value)} />
              </Grid>
            </Grid>
          </Grid>

          {/* RIGHT SIDE: PHOTO UPLOAD (xs=3) */}
          <Grid className="col-sm-2" item xs={12} md={3}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              sx={{
                border: "1px dashed #ccc",
                p: 2,
                borderRadius: 2,
                height: "100%",
                minHeight: "250px",
                bgcolor: "#fafafa"
              }}
            >
              <Typography variant="caption" sx={{ mb: 1, fontWeight: "bold" }}>FATHER'S PHOTO</Typography>

              <Avatar
                variant="rounded"
                src={form.father_photo || ""}
                sx={{ width: 150, height: 180, mb: 2, border: "1px solid #ddd" }}
              >
                {uploading ? <CircularProgress size={24} /> : "No Image"}
              </Avatar>

              <Button
                variant="contained"
                component="label"
                size="small"
                startIcon={<CloudUploadIcon />}
                disabled={uploading}
                sx={{ bgcolor: "teal", "&:hover": { bgcolor: "#00695c" } }}
              >
                {uploading ? "Uploading..." : "Upload Photo"}
                <input type="file" hidden accept="image/*" onChange={handlePhotoChange} />
              </Button>

              {form.father_photo && (
                <IconButton
                  color="error"
                  size="small"
                  sx={{ mt: 1 }}
                  onClick={() => handleChange("father_photo", "")}
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
          </Grid>

         
        </Grid>
      </Paper>
    </Box>
  );
}

export default FatherInfo;